export default __webpack_public_path__ + "static/media/error-icon.7a063234.svg";